import { render, staticRenderFns } from "./VerifyEmailConfirm.vue?vue&type=template&id=f96b2bf0&"
import script from "./VerifyEmailConfirm.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailConfirm.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmailConfirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports